// Generated types for MBSE_Package
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLElementReadAPI, SysMLElementWriteAPI } from '../../sysml/types/sysmlelement';
import { SysMLElementReadAPISchemaObject, SysMLElementWriteAPISchemaObject } from '../../sysml/types/sysmlelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface MBSE_PackageReadAPI extends SysMLElementReadAPI {
  /** Category of product */
  product_category?: string | null;
}

export interface MBSE_PackageWriteAPI extends SysMLElementWriteAPI {
  /** Category of product */
  product_category?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const MBSE_PackageReadAPISchema: z.ZodType<MBSE_PackageReadAPI> = SysMLElementReadAPISchemaObject.extend({
  product_category: z.string().nullable().optional(),
}).passthrough();

export const MBSE_PackageWriteAPISchema: z.ZodType<MBSE_PackageWriteAPI> = SysMLElementWriteAPISchemaObject.extend({
  product_category: z.string().nullable().optional(),
}).passthrough();
